import Icon from '../components/Icon.vue'

Icon.register({"exclamation-triangle":{"width":576,"height":512,"paths":[{"d":"M569.5 440C588 472 564.8 512 527.9 512H48.1C11.1 512-11.9 471.9 6.5 440L246.4 24C264.9-8 311.1-8 329.6 24L569.5 440zM288 354C262.6 354 242 374.6 242 400S262.6 446 288 446 334 425.4 334 400 313.4 354 288 354zM244.3 188.7L251.7 324.7C252.1 331 257.4 336 263.7 336H312.3C318.6 336 323.9 331 324.3 324.7L331.7 188.7C332 181.8 326.6 176 319.7 176H256.3C249.4 176 244 181.8 244.3 188.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/exclamation-triangle.js
// module id = yqAZ
// module chunks = 0